<template>
    <div class="network-dialog">
        <div class="network-dialog-wrap">
            <div class="w35">
                <div class="right">
                    <h2>{{ $t('networkDialog.overview') }}</h2>
                    <div
                        class="network-dialog-wrap-header"
                        style="padding-top: 2.5rem"
                    >
                        <img src="../../../assets/image/leaderpage/l1.png" />
                        <span>{{ $t('networkDialog.photovoltaic') }}</span>
                        <img
                            src="../../../assets/image/leaderpage/s-heng.png"
                        />
                    </div>
                    <div class="network-dialog-wrap-data">
                        <div class="network-dialog-wrap-data-item">
                            <span class="span1">{{ $t('networkDialog.installedCapacity') }}:</span>
                            <span class="">3481.82kW</span>
                        </div>
                        <div class="network-dialog-wrap-data-item">
                            <span class="span1">{{ $t('networkDialog.PVInverter') }}:</span>
                            <span>79{{ $t('networkDialog.pcs') }}</span>
                        </div>
                    </div>
                    <div class="network-dialog-wrap-header">
                        <img src="../../../assets/image/leaderpage/l1.png" />
                        <span>{{ $t('networkDialog.powerStorage') }}</span>
                        <img
                            src="../../../assets/image/leaderpage/s-heng.png"
                        />
                    </div>
                    <div class="network-dialog-wrap-data">
                        <div class="network-dialog-wrap-data-item">
                            <span class="span1">{{ $t('networkDialog.totalCapacity') }}:</span>
                            <span class="">460kWh</span>
                        </div>
                        <div class="network-dialog-wrap-data-item">
                            <span class="span1">{{ $t('networkDialog.outputPower') }}:</span>
                            <span>200kW</span>
                        </div>
                    </div>
                    <div class="network-dialog-wrap-header">
                        <img src="../../../assets/image/leaderpage/l1.png" />
                        <span>{{ $t('networkDialog.EVCharger') }}</span>
                        <img
                            src="../../../assets/image/leaderpage/s-heng.png"
                        />
                    </div>
                    <div class="network-dialog-wrap-data">
                        <div class="network-dialog-wrap-data-item">
                            <span class="span1">{{ $t('networkDialog.DCCharger') }}:</span>
                            <span class="">2{{ $t('networkDialog.pcs') }}</span>
                        </div>
                        <div class="network-dialog-wrap-data-item">
                            <span class="span1">{{ $t('networkDialog.ACCharger') }}:</span>
                            <span>8{{ $t('networkDialog.pcs') }}</span>
                        </div>
                    </div>
                </div>
                <div class="right">
<!--                    <h2>光伏发电情况</h2>-->
                    <h2>{{ $t('networkDialog.PVPowerGeneration') }}</h2>
                    <div
                        class="network-dialog-wrap-ch"
                        style="padding-top: 2rem;"
                    >
                        <div
                            class="network-dialog-wrap-ch-left"
                            style="text-align: center"
                        >
                            <img
                                src="../../../assets/image/network/guangfu.png"
                            />
                        </div>
                        <div class="network-dialog-wrap-ch-right">
                            <div class="network-dialog-wrap-ch-right-box" >
                                    <img
                                        src="../../../assets/image/leaderpage/l1.png"
                                    /> 
                                                               
                                    <span>{{ $t('networkDialog.dailyGeneration') }}:</span>
                                    <span>{{ powerData && powerData.day && powerData.day.fd_power }}{{ powerData && powerData.day && powerData.day.power_unit }}</span>
                                
                            </div>


                            <div class="network-dialog-wrap-ch-right-box" >
                                <img
                                    src="../../../assets/image/leaderpage/l1.png"
                                />

                                <span>{{ $t('networkDialog.frontDailyGeneration') }}:</span>
                                <span>{{ frontPowerData && frontPowerData.day && frontPowerData.day.fd_power }}{{ frontPowerData && frontPowerData.day && frontPowerData.day.power_unit }}</span>

                            </div>


                            <div class="network-dialog-wrap-ch-right-box">
                                <img
                                    src="../../../assets/image/leaderpage/l2.png"
                                />
<!--                                <span>月发电量:</span>-->
                                <span>{{ $t('networkDialog.monthlyGeneration') }}:</span>
                                <span>{{ powerData && powerData.month && powerData.month.fd_power }}{{ powerData && powerData.month && powerData.month.power_unit }}</span>
                            </div>
                            <div class="network-dialog-wrap-ch-right-box">
                                <img
                                    src="../../../assets/image/leaderpage/l2.png"
                                />
                                <!--                                <span>月发电量:</span>-->
                                <span>{{ $t('networkDialog.frontMonthlyGeneration') }}:</span>
                                <span>{{ frontPowerData && frontPowerData.month && frontPowerData.month.fd_power }}{{ frontPowerData && frontPowerData.month && frontPowerData.month.power_unit }}</span>
                            </div>
                            <div class="network-dialog-wrap-ch-right-box">
                                <img
                                    src="../../../assets/image/leaderpage/l3.png"
                                />
                                <span>{{ $t('networkDialog.yearlyGeneration') }}:</span>
<!--                                <span>年发电量:</span>-->
                                <span>{{ powerData && powerData.year && powerData.year.fd_power }}{{ powerData && powerData.year && powerData.year.power_unit }}</span>
                            </div>

                            <div class="network-dialog-wrap-ch-right-box">
                                <img
                                    src="../../../assets/image/leaderpage/l3.png"
                                />
                                <span>{{ $t('networkDialog.frontYearlyGeneration') }}:</span>
                                <!--                                <span>年发电量:</span>-->
                                <span>{{ frontPowerData && frontPowerData.year && frontPowerData.year.fd_power }}{{ frontPowerData && frontPowerData.year && frontPowerData.year.power_unit }}</span>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
            <div class="w30">
                <div class="center-top">
                    <div class="yuan">
                        <div
                            class="yuan-img box animate__animated animate__bounceIn"
                        >
                            <div class="a1">
                                <img
                                    src="../../../assets/image/img/1.png"
                                    alt=""
                                />
                            </div>
                            <div class="a2">
                                <img
                                    src="../../../assets/image/img/2.png"
                                    alt=""
                                />
                            </div>
                            <div class="a3">
                                <img
                                    src="../../../assets/image/img/3.png"
                                    alt=""
                                />
                            </div>
                            <div class="a4">
                                <template v-if="show_data == 1">
                                    <img
                                        src="../../../assets/image/img/4.png"
                                        alt=""
                                    />
                                    <div class="left-title">
<!--                                        <div class="title-style-custom">-->
<!--                                            当年光伏发电量：<i>{{ powerData && powerData.year && powerData.year.fd_power }}</i>&nbsp;kWh-->
<!--                                        </div>-->
                                        <div class="title-style-custom">
                                            {{ $t('networkDialog.PVPowerGeneration') }} {{ curYear }}：<i>{{ powerData && powerData.year && powerData.year.fd_power }}</i>&nbsp;{{ powerData && powerData.year && powerData.year.power_unit }}
                                        </div>
<!--                                        <div class="title-style-custom" style="margin-top: 0.5rem;">-->
<!--                                            当年上网电量：<i>{{ powerData && powerData.year && powerData.year.sw_power }}</i>&nbsp;kWh-->
<!--                                        </div>-->
                                        <div class="title-style-custom" style="margin-top: 0.5rem;">
                                            {{ $t('networkDialog.totalPowertoGridYTD') }}：<i>{{ powerData && powerData.year && powerData.year.sw_power }}</i>&nbsp;{{ powerData && powerData.year && powerData.year.power_unit }}
                                        </div>
                                        <!-- <div class="title-style2">
                                            
                                        </div> -->
                                    </div>
                                </template>
                                <template v-if="show_data == 2">
                                    <img
                                        src="../../../assets/image/img/5.png"
                                        alt=""
                                    />

                                    <div class="left-title">
                                        <div class="title-style">602</div>
                                        <div
                                            class="title-style"
                                            style="
                                        font-size: 1rem;
                                        margin-top: 5px;
                                        margin-bottom: 5px;
                                    "
                                        >
                                            kW·h
                                        </div>
<!--                                        <div class="title-style2">-->
<!--                                            月发电量-->
<!--                                        </div>-->
                                        <div class="title-style2">
                                            {{ $t('networkDialog.monthlyGeneration') }}
                                        </div>
                                    </div>
                                </template>
                                <template v-if="show_data == 3">
                                    <img
                                        src="../../../assets/image/img/6.png"
                                        alt=""
                                    />

                                    <div class="left-title">
                                        <div class="title-style">602</div>
<!--                                        <div class="title-style2">-->
<!--                                            月循环次数-->
<!--                                        </div>-->
                                        <div class="title-style2">
                                            {{ $t('networkDialog.monthlyRecycleNumbers') }}
                                        </div>
                                    </div>
                                </template>
                                <template v-if="show_data == 4"
                                    ><img
                                        src="../../../assets/image/img/7.png"
                                        alt=""
                                    />

                                    <div class="left-title">
                                        <div class="title-style">602</div>
                                        <div
                                            class="title-style"
                                            style="
                                        font-size: 1rem;
                                        margin-top: 5px;
                                        margin-bottom: 5px;
                                    "
                                        >
                                            kW·h
                                        </div>
<!--                                        <div class="title-style2">-->
<!--                                            月充电量-->
<!--                                        </div>-->
                                        <div class="title-style2">
                                            {{ $t('networkDialog.monthly') }}
                                        </div>
                                    </div>
                                </template>
                            </div>
                            <div class="hu1">
                                <div
                                    class="hu1-title"
                                    :class="[
                                        this.show_data == 1
                                            ? 'color-huang'
                                            : 'color-lan'
                                    ]"
                                >
                                    <!-- 微电网运行收益总览 -->
                                </div>
                            </div>
                            <div class="hu2">
                                <div
                                    class="hu2-title"
                                    :class="[
                                        this.show_data == 2
                                            ? 'color-huang'
                                            : 'color-lan'
                                    ]"
                                >
                                    <!-- 光伏发电 -->
                                </div>
                            </div>
                            <div class="hu3">
                                <div
                                    class="hu3-title"
                                    :class="[
                                        this.show_data == 3
                                            ? 'color-huang'
                                            : 'color-lan'
                                    ]"
                                >
                                    <!-- 上网 -->
                                </div>
                            </div>
                            <div class="hu4">
                                <div
                                    class="hu4-title"
                                    :class="[
                                        this.show_data == 4
                                            ? 'color-huang'
                                            : 'color-lan'
                                    ]"
                                >
                                    <!-- 充电桩 -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="center-down">
<!--                    <h2>充电桩充电情况</h2>-->
                    <h2>{{ $t('networkDialog.EVChargingCapacity') }}</h2>
                    <div class="network-dialog-wrap-ch">
                        <div
                            class="network-dialog-wrap-ch-left"
                            style="text-align: center"
                        >
                            <img
                                src="../../../assets/image/network/dianliang.png"
                            />
                        </div>
                        <div class="network-dialog-wrap-ch-right">
                            <div class="network-dialog-wrap-ch-right-box">
                                <img
                                    src="../../../assets/image/leaderpage/l1.png"
                                />
<!--                                <span>日充电量:</span>-->
                                <span>{{ $t('networkDialog.daily') }}:</span>
                                <span>{{ elePowerDay }}kW·h</span>
                            </div>
                            <div class="network-dialog-wrap-ch-right-box">
                                <img
                                    src="../../../assets/image/leaderpage/l2.png"
                                />
<!--                                <span>月充电量:</span>-->
                                <span>{{ $t('networkDialog.monthly') }}:</span>
                                <span>{{ elePowerMonth }}kW·h</span>
                            </div>
                            <div class="network-dialog-wrap-ch-right-box">
                                <img
                                    src="../../../assets/image/leaderpage/l3.png"
                                />
<!--                                <span>年充电量:</span>-->
                                <span>{{ $t('networkDialog.yearly') }}:</span>
                                <span>{{ elePowerYear }}kW·h</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w35">
                <div class="right">
<!--                    <h2>光伏发电情况</h2>-->
                    <h2>{{ $t('networkDialog.radiationComparison') }}</h2>
                    <div class="chart-box">
                        <div class="chart-box-type">
                            <el-button
                                type="primary"
                                size="small"
                                :class="
                                    light_active == 'day' ? 'activeClass' : ''
                                "
                                @click="lightClick('day')"
                                >{{ $t('common.day') }}</el-button
                            >
                            <el-button
                                type="primary"
                                size="small"
                                :class="
                                    light_active == 'month' ? 'activeClass' : ''
                                "
                                @click="lightClick('month')"
                                >{{ $t('common.month') }}</el-button
                            >
                            <el-button
                                type="primary"
                                size="small"
                                :class="
                                    light_active == 'year' ? 'activeClass' : ''
                                "
                                @click="lightClick('year')"
                                >{{ $t('common.year') }}</el-button
                            >
                        </div>
                        <div class="chart-box-data">
                            <v-chart
                                auto-resize
                                :options="rightDataTop"
                                ref="chart"
                                theme="ovilia-green"
                            />
                        </div>
                    </div>
                </div>
                <div class="right">
<!--                    <h2>充电收益情况</h2>-->
                    <h2>{{ $t('networkDialog.EVCOperationRevenue') }}</h2>
                    <div class="chart-box">
                        <div class="chart-box-type">
                            <el-button
                                type="primary"
                                size="small"
                                @click="eleClick('day')"
                                :class="
                                    ele_active == 'day' ? 'activeClass' : ''
                                "
                                >{{ $t('networkDialog.daily') }}</el-button
                            >
                            <el-button
                                type="primary"
                                size="small"
                                @click="eleClick('month')"
                                :class="
                                    ele_active == 'month' ? 'activeClass' : ''
                                "
                                >{{ $t('networkDialog.monthly') }}</el-button
                            >
                            <el-button
                                type="primary"
                                size="small"
                                @click="eleClick('year')"
                                :class="
                                    ele_active == 'year' ? 'activeClass' : ''
                                "
                                >{{ $t('networkDialog.yearly') }}</el-button
                            >
                        </div>
                        <div class="chart-box-data">
                            <v-chart
                                auto-resize
                                :options="rightDataDown"
                                ref="chart"
                                theme="ovilia-green"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";

import "echarts/lib/chart/pie";
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import "echarts/lib/component/graphic";
import * as api from "@/http/api.js";
import moment from "moment";
export default {
    data() {
        return {
            show_data: 1,
            is_outline_count: "", //离线数
            recharge_count: "", //充电数
            point_type_count: "", //连接数
            light_active: "day", //日
            curYear: moment().format('YYYY'),
            daytime: "",
            monthtime: "",
            yeartime: "",
            light_x: [],
            light_y: [],
            ele_active: "day", //日
            ele_x: [],
            ele_y: [],
            rightDataDownXName: '小时',
            elePowerDay: "",
            elePowerMonth: "",
            elePowerYear: "",
            dayList: ["0时", "1时", "2时", "3时", "4时", "5时", "6时", "7时", "8时", "9时", "10时", "11时", "12时", "13时", "14时", "15时", "16时", "17时", "18时", "19时", "20时", "21时", "22时", "23时"],
            monthList: ["1天", "2天", "3天", "4天", "5天", "6天", "7天", "8天", "9天", "10天", "11天", "12天", "13天", "14天", "15天", "16天", "17天", "18天", "19天", "20天", "21天", "22天", "23天", "24天", "25天", "26天", "27天", "28天", "29天", "30天", "31天"],
            yearList: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
            powerData: {},
            frontPowerData: {},
            powerDataListBasic: {},
            powerDataListBasic_x: [],
            powerDataListBasic_y: [],
            powerDataListBasic_fzd: [],
        };
    },
    mounted() {
        this.light_active = "day";
        this.ele_active = "day";
        this.getMicrogridCount();
        this.getSysDate();
        this.getRealTimeGfPower();
        this.getRealTimeGfPowerList();
   
        
    },
    methods: {
        tabClick(tab) {
            this.show_data = tab;
        },
        formatDate(value){
            if (!value) return "";
            const date = new Date(value);
            const year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            month = month < 10 ? "0" + month : month;
            day = day < 10 ? "0" + day : day;

            return `${year}-${month}-${day}`;
            
        },
        
        /**
         * 获取系统时间
         */
        getSysDate() {
            api.getSysDate1().then(res => {
                if (res) {
                    this.daytime = res.bus_json.sysdate;
                    this.monthtime = res.bus_json.sysdate3;
                    this.yeartime = res.bus_json.sysdate4;
                    // 获取光伏日
                    this.getMicrogridCostAndPower(10);
                    // 获取充电日
                    this.getActivePowerDay(20);
                    this.getActivePowerSum(10);
                    this.getActivePowerSum(20);
                    this.getFrontRealTimeGfPower();
                }
            });
        },
        getRealTimeGfPower() {
            api.getRealTimeGfPower().then(res => {
                if (res) {
                    this.powerData = res.bus_json;
                }
            });
        },
        getFrontRealTimeGfPower() {
          let  params = {
              show_day: moment(new Date(this.daytime)).subtract(1, 'days').format('YYYY-MM-DD'),
              show_month: moment(new Date(this.monthtime)).subtract(1, 'months').format('YYYY-MM-DD'),
              show_year: moment(new Date(this.yeartime)).subtract(1, 'years').format('YYYY-MM-DD'),
            };
            api.getRealTimeGfPower(params).then(res => {
                if (res) {
                    this.frontPowerData = res.bus_json;
                  
                }
            });
        },
        getRealTimeGfPowerList() {
            api.getRealTimeGfPowerList().then(res => {
                if (res) {
                    this.powerDataListBasic = res.bus_json;
                    this.lightClick(this.light_active);
                }
            });
        },
        // 发电量合计
        getActivePowerSum(point_type) {
            // api.getActivePowerSum({ date: this.daytime, point_type }).then(
            //     res => {
            //         if (res) {
                        const bus_json = {
                            activePowerDay: "362.65",
                            activePowerDayCO2: "0.12",
                            activePowerDayPrice: "306.09",
                            activePowerDayTce: "0.04",
                            activePowerMonth: "2877.45",
                            activePowerMonthCO2: "0.98",
                            activePowerMonthPrice: "2429.99",
                            activePowerMonthTce: "0.35",
                            activePowerYear: "2877.45",
                            activePowerYearCO2: "0.98",
                            activePowerYearPrice: "2429.99",
                            activePowerYearTce: "0.35",
                        }
                        if (point_type == 10) {
                        } else {
                            // 充电桩
                            // 光伏
                            this.elePowerDay = bus_json.activePowerDay;
                            this.elePowerMonth = bus_json.activePowerMonth;
                            this.elePowerYear = bus_json.activePowerYear;
                        }
            //         }
            //     }
            // );
        },
        // 光伏日月年切换
        lightClick(val) {
            this.light_active = val;
            if (val == "day") {
                // this.getActivePowerDay(10);
                this.getMicrogridCostAndPower(10);
                this.powerDataListBasic_x = this.powerDataListBasic && this.powerDataListBasic.day && this.powerDataListBasic.day.time_list;
                this.powerDataListBasic_x.forEach((item,index)=>{
                    this.powerDataListBasic_x[index]=item+"时"
                });
                
                this.powerDataListBasic_y = this.powerDataListBasic && this.powerDataListBasic.day && this.powerDataListBasic.day.active_power_list;
                this.powerDataListBasic_fzd = this.powerDataListBasic && this.powerDataListBasic.day && this.powerDataListBasic.day.hj_active_power_list;
            } else if (val == "month") {
                this.getMicrogridCostAndPower(20);
                this.powerDataListBasic_x = this.powerDataListBasic && this.powerDataListBasic.month && this.powerDataListBasic.month.time_list;
                this.powerDataListBasic_x.forEach((item,index)=>{
                    this.powerDataListBasic_x[index]=item+"天"
                });
                this.powerDataListBasic_y = this.powerDataListBasic && this.powerDataListBasic.month && this.powerDataListBasic.month.active_power_list;
                this.powerDataListBasic_fzd = this.powerDataListBasic && this.powerDataListBasic.month && this.powerDataListBasic.month.hj_active_power_list;
            } else if (val == "year") {
                this.getMicrogridCostAndPower(30);
                this.powerDataListBasic_x = this.powerDataListBasic && this.powerDataListBasic.year && this.powerDataListBasic.year.time_list;
                this.powerDataListBasic_x.forEach((item,index)=>{
                    this.powerDataListBasic_x[index]=item+"月"
                });
                this.powerDataListBasic_y = this.powerDataListBasic && this.powerDataListBasic.year && this.powerDataListBasic.year.active_power_list;
                this.powerDataListBasic_fzd = this.powerDataListBasic && this.powerDataListBasic.year && this.powerDataListBasic.year.hj_active_power_list;
            }
        },
        // 充电收益
        eleClick(val) {
            this.ele_active = val;
            if (val == "day") {
                this.rightDataDownXName = '小时';
                this.getActivePowerDay(20);
            } else if (val == "month") {
                this.rightDataDownXName = '天';
                this.getActivePowerMonth(20);
            } else if (val == "year") {
                this.rightDataDownXName = '月';
                this.getActivePowerYear(20);
            }
        },
        getMicrogridCostAndPower(point_type) {
            // api.getMicrogridCostAndPower({
            //     date: this.daytime,
            //     point_type
            // }).then(res => {
            //     if (res) {
                if(point_type == 10) {
                    this.light_x = this.dayList;
                    this.light_y = this.getRandom(24);
                } else if(point_type == 20) {
                    this.light_x = this.monthList;
                    this.light_y = this.getRandom(31);
                } else if(point_type == 30) {
                    this.light_x = this.yearList;
                    this.light_y = this.getRandom(12);
                }
                    
                    // res.bus_json.activePowerList.map(item => {
                    //     this.light_y.push(item.gf_cost_sum);
                    // });
            //     }
            // });
        },
        getRandom(num) {
            let arr = [];
            for(let i=0; i< num; i++) {
                var random1 = (Math.random()*(15-10)).toFixed(2);
                arr.push(random1)
            }
            return arr;
        },
        // 日统计
        getActivePowerDay(point_type) {
            // api.getActivePowerDay({ date: this.daytime, point_type }).then(
            //     res => {
            //         if (res) {
                        // 光伏日
                        if (point_type == 10) {
                            this.light_x = this.dayList;
                            this.light_y = this.getRandom(24);
                            // res.bus_json.activePowerList.map(item => {
                            //     this.light_y.push(item.power_price);
                            // });
                        } else if (point_type == 20) {
                            this.ele_x = this.dayList;
                            this.ele_y = this.getRandom(24);
                            // res.bus_json.activePowerList.map(item => {
                            //     this.ele_y.push(item.power_price);
                            // });
                        }
            //         }
            //     }
            // );
        },
        // 月统计
        getActivePowerMonth(point_type) {
            // api.getActivePowerMonth({ date: this.monthtime, point_type }).then(
            //     res => {
            //         if (res) {
                        // 光伏月
                        if (point_type == 10) {
                            this.light_x = this.monthList;
                            this.light_y = this.getRandom(31);
                            // res.bus_json.activePowerList.map(item => {
                            //     this.light_y.push(item.power_price);
                            // });
                        } else if (point_type == 20) {
                            this.ele_x = this.monthList;
                            this.ele_y = this.getRandom(31);
                            // res.bus_json.activePowerList.map(item => {
                            //     this.ele_y.push(item.power_price);
                            // });
                        }
            //         }
            //     }
            // );
        },
        // 年统计
        getActivePowerYear(point_type) {
            // api.getActivePowerYear({ date: this.yeartime, point_type }).then(
            //     res => {
            //         if (res) {
                        if (point_type == 10) {
                            this.light_x = this.yearList;
                            this.light_y = this.getRandom(12);
                            // res.bus_json.activePowerList.map(item => {
                            //     this.light_y.push(item.power_price);
                            // });
                        } else if (point_type == 20) {
                            this.ele_x = this.yearList;
                            this.ele_y = this.getRandom(12);
                            // res.bus_json.activePowerList.map(item => {
                            //     this.ele_y.push(item.power_price);
                            // });
                        }
            //         }
            //     }
            // );
        },
        // 设备总览
        getMicrogridCount() {
            // api.getMicrogridCount().then(res => {
            //     if (res) {
                    const bus_json = {
                        is_outline_count: 0,
                        point_type_count: 7
                    };
                    this.is_outline_count = bus_json.is_outline_count;
                    this.recharge_count = bus_json.recharge_count;
                    this.point_type_count = bus_json.point_type_count;
            //     }
            // });
        },
        closeDialog() {
            this.$emit("update:networkDialogShow", false);
        }
    },
    
    computed: {
        rightDataTop() {
            const option = {
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "cross",
                        label: {
                            backgroundColor: "#6a7985"
                        }
                    },
                    formatter: (params) => {
                        let returnVal = params[0].axisValueLabel;
                        for(var i=0; i<params.length; i++) {
                            // console.log(params[i])
                            returnVal += '<br/>'+ params[i].marker + params[i].seriesName + ': '  + params[i].value + ' ' + (params[i].seriesName == '光伏发电量' ? 'kWh' : 'KJ')
                        }
                        return returnVal
                    }
                },
                // legend: {
                //     // data: this.quxian.legendData,
                //     right: "36px",
                //     top: "0px",
                //     textStyle: { fontSize: 12, color: "#fff" }
                // },
                grid: {
                    left: "5%",
                    right: "4%",
                    top: "20%",
                    bottom: "10%",
                    containLabel: true
                },
                 color: ["#00b7ee", "#0b3a44"],
                
                xAxis: [
                    {
                        type: "category",
                        // boundaryGap: false,
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#2c6986" // 颜色
                            }
                        },
                        data: this.powerDataListBasic_x
                    }
                ],
                yAxis: [
                    {
                        name: "kWh",
                        type: "value",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: "#999999" // 颜色
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#2c6986" // 颜色
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        },
                        nameTextStyle: {
                            color: "#999999",
                            padding: 10,
                            fontSize: 11
                        }
                    },
                    {
                        name: "",
                        type: "value",
                        nameTextStyle: {
                            color: "#999999",
                            fontSize: 10
                        },
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: this.$t('networkDialog.gffdl'),
                        type: "line",
                        // name: this.quxian.legendData[0],
                        label: {
                            normal: { 
                                show: false,
                                position: "top"
                            }
                        },
                        
                        smooth: true,
                        symbolSize: 0.1,
                        areaStyle: {},
                        data: this.powerDataListBasic_y
                    },
                    {
                        name: this.$t('networkDialog.zfs'),
                        type: 'line',
                        yAxisIndex: 1,
                     //   smooth: true,
                        symbolSize: 0,
                        itemStyle: {  /*设置折线颜色*/
                            normal: {
                                color: '#F8B551'
                            }
                        },
                        data: this.powerDataListBasic_fzd
                    }
                ]
            };
            return option;
        },
        rightDataDown() {
            const option = {
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "cross",
                        label: {
                            backgroundColor: "#6a7985"
                        }
                    },
                    formatter: (params) => {
                        return params[0].axisValueLabel + '<br/>'+ params[0].marker + params[0].seriesName + ': '  + params[0].value + '元'
                    }
                },
                // legend: {
                //     // data: this.quxian.legendData,
                //     right: "36px",
                //     top: "0px",
                //     textStyle: { fontSize: 12, color: "#fff" }
                // },
                grid: {
                    left: "5%",
                    right: "9%",
                    top: "20%",
                    bottom: "10%",
                    containLabel: true
                },
                color: ["#00b7ee", "#0b3a44"],
                
                xAxis: [
                    {
                        name: this.rightDataDownXName,
                        type: "category",
                        // boundaryGap: false,
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#2c6986" // 颜色
                            }
                        },
                        nameTextStyle: {
                            color: "#999999",
                         //   padding: 10,
                          //  fontSize: 11
                        },
                        data: this.ele_x
                    }
                ],
                yAxis: [
                    {
                        name: "元",
                        type: "value",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: "#999999" // 颜色
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#2c6986" // 颜色
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        },
                        nameTextStyle: {
                            color: "#999999",
                            padding: 10,
                            fontSize: 11
                        }
                    }
                ],
                series: [
                    {
                        type: "line",
                        name: '充电收益情况',
                        label: {
                            normal: {
                                show: false,
                                position: "top"
                            }
                        },
                        smooth: true,
                        symbolSize: 0.1,
                        areaStyle: {},
                        
                        data: this.ele_y
                    }
                ]
            };
            return option;
        }
    }
};
</script>
<style lang="scss">
.network-dialog {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0 40px;
    &-wrap {
        width: 100%;
        height: 42rem;
        display: flex;
        &-header {
            text-align: left;
            padding-top: 1rem;
            // margin-bottom: 0.8rem;
            img {
                margin-left: 1rem;
            }
            span {
                color: white;
                display: inline-block;
                margin-left: 0.5rem;
                font-size: 0.8rem;
            }
        }
        &-data {
            display: flex;
            flex-wrap: wrap;
            &-item {
                width: 50%;
                color: white;
                height: 2.5rem;
                font-size: 0.8rem;
                line-height: 2.5rem;
                .span1 {
                    display: inline-block;
                    margin-left: 1rem;
                    margin-right: 0.5rem;
                }
            }
        }
        &-ele {
            width: 100%;
            padding: 3rem;
            text-align: left;
            &-item {
                text-align: left;
                color: white;
                font-size: 0.8rem;
                line-height: 2rem;
                height: 2rem;
                img {
                    margin-right: 1rem;
                }
                span {
                    display: inline-block;
                    margin-right: 1rem;
                }
            }
        }
        &-ch {
            width: 100%;
            padding-top: 2rem;
            display: flex;
            height: 10rem;
            align-items: center;
            &-left {
                width: 35%;
                img {
                    width: 100%;
                }
            }
            &-right {
                width: 62%;
                margin-left: 3%;
                &-box {
                    text-align: left;
                    color: white;
                    font-size: 0.8rem;
                    line-height: 2.2rem;
                    height: 2.2rem;
                    img {
                        margin-right: 1rem;
                    }
                    span {
                        display: inline-block;
                        margin-right: 1rem;
                    }
                }
            }
        }
        .chart-box {
            padding-top: 7%;
            height: 93%;
            &-type {
                text-align: right;
                padding-right: 1rem;
            }
            &-data {
                height: 80%;
                .echarts {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        h2 {
            color: white;
            float: left;
            font-size: 0.8rem;
            font-weight: 1rem;
            margin-left: 3rem;
            margin-top: 0.5rem;
            width: 10rem;
        }
        .w35 {
            // padding: 0 0.5%;
            width: 34%;
            height: 100%;
            text-align: left;
            .left-top {
                height: 65%;
                width: 100%;
                background: url("../../../assets/image/network/left-top.png")
                    no-repeat;
                background-size: 100% 100%;
            }
            .left-down {
                margin-top: 6%;
                height: 26%;
                width: 100%;
                background: url("../../../assets/image/network/left-down.png");
                background-size: 100% 100%;
            }
            .right {
                margin-top: 4%;
                margin-bottom: 1%;
                height: 45%;
                width: 100%;
                background: url("../../../assets/image/network/right.png");
                background-size: 100% 100%;
            }
        }
        .w30 {
            width: 32%;
            height: 100%;
            margin-left: 1%;
            .center-top {
                width: 100%;
                height: 53%;
                position: relative;
                .yuan {
                    margin-top: 1rem;
                    margin-left: 2rem;
                    width: 100%;
                    height: 100%;
                    position: absolute;

                    .yuan-img {
                        width: 100%;
                        height: 100%;
                        position: absolute;
                        left: 11%;
                        .hu1 {
                            width: 40%;
                            height: 10%;
                            top: -1rem;
                            left: 13rem;
                            position: relative;

                            .hu1-title {
                                position: relative;
                                left: 0rem;
                                top: 1.5rem;
                                font-size: 0.9rem;
                                color: #e08467;
                                // cursor: pointer;
                            }
                        }

                        .hu2 {
                            width: 29%;
                            height: 18%;
                            top: -1rem;
                            left: 16rem;
                            position: relative;

                            .hu2-title {
                                position: relative;
                                left: 0rem;
                                top: 2rem;
                                font-size: 0.9rem;
                                color: #76b7ff;
                                // cursor: pointer;
                            }
                        }

                        .hu3 {
                            width: 21%;
                            height: 18%;
                            top: -1.5rem;
                            left: 16.5rem;
                            position: relative;

                            .hu3-title {
                                position: relative;
                                left: 0rem;
                                top: 2rem;
                                font-size: 0.9rem;
                                color: #76b7ff;
                                // cursor: pointer;
                            }
                        }
                        .hu4 {
                            width: 24%;
                            height: 20%;
                            top: -1.5rem;
                            left: 15.5rem;
                            position: relative;

                            .hu4-title {
                                position: relative;
                                left: 0rem;
                                top: 2rem;
                                font-size: 0.9rem;
                                color: #76b7ff;
                                // cursor: pointer;
                            }
                        }
                        .total-profit {
                            display: flex;
                            height: 100%;
                            width: 100%;
                            position: absolute;

                            .left-title {
                                align-self: center;
                                margin-left: 6.6rem;
                                margin-top: 0.3rem;
                            }
                            .right-title {
                                align-self: center;
                                // margin-top: -1.5rem;
                            }
                        }
                        .total-profit2 {
                            height: 100%;
                            background: url(../../../assets/image/leaderpage/s-yuan1.png)
                                no-repeat;
                            background-size: contain;
                        }
                        .title-style {
                            color: #e08467;
                            font-size: 1.4rem;
                            font-weight: bold;
                        }
                        .title-style2 {
                            display: inline-block;
                            margin-top: 5px;
                            font-size: 0.8rem;
                            font-weight: bold;
                            color: #fff;
                        }
                        .title-style-custom {
                            font-size: 0.9rem;
                            color: #fff;
                            i {
                                font-size: 1rem;
                                font-weight: bold;
                                color: #e08467;
                            }
                        }
                        .ri-title-style {
                            color: #e08467;
                            font-size: 0.8rem;
                            margin-bottom: 0.5rem;
                            margin-left: 0.5rem;
                        }
                        .ri-title-style2 {
                            margin-left: 0.5rem;
                            display: inline-block;
                            margin-top: 5px;
                            font-size: 0.8rem;
                            margin-bottom: 0.5rem;
                        }
                    }
                }
            }
            .center-down {
                width: 100%;
                height: 49%;
                background-size: 98% 88% !important;
                background: url("../../../assets/image/network/center.png")
                    no-repeat;
            }
        }
    }
    .color-lan {
        color: #76b7ff !important;
    }
    .color-lv {
        color: #51ffc4 !important;
    }
    .color-yellow {
        color: #fbc12c !important;
    }
    .color-huang {
        color: #e08467 !important;
    }
    .a4,
    .a1,
    .a2,
    .a3 {
        position: absolute;
        top: -0.5rem;

        img {
            width: 21rem;
            height: 21rem;
        }
        .left-title {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            cursor: pointer;
            text-align: center;
        }
        .hover-wrap {
            z-index: 55;
            cursor: pointer;
        }
        .hover-down {
            display: none;
            position: absolute;
        }
    }
    .animate__animated.animate__bounceIn {
        --animate-duration: 1.5s;
    }
    .a3 {
        animation: rotateAr 6s linear 3s infinite reverse;
        -webkit-animation: rotateAr 6s linear 3s infinite reverse;
        -moz-animation: rotateAr 6s linear 3s infinite reverse;
        -ms-animation: rotateAr 6s linear 3s infinite reverse;
        -o-animation: rotateAr 6s linear 3s infinite reverse;
    }
    .a2 {
        animation: rotateArround 6s linear 1s infinite;
        -webkit-animation: rotateArround 6s linear 1s infinite;
        -moz-animation: rotateArround 6s linear 1s infinite;
        -ms-animation: rotateArround 6s linear 1s infinite;
        -o-animation: rotateArround 6s linear 1s infinite;
    }
    .a1 {
        // background: url(../../../assets/image/img/1.png) no-repeat;
        animation: rotateArround 6s linear 1s reverse;
        -webkit-animation: rotateArround 6s linear 1s reverse;
        -moz-animation: rotateArround 6s linear 1s reverse;
        -ms-animation: rotateArround 6s linear 1s reverse;
        -o-animation: rotateArround 3s linear 1s reverse;
    }
    .right-title {
        align-self: center;
        // margin-top: -1.5rem;

        .ri-title-style {
            color: #e08467;
            font-size: 0.8rem;
            margin-bottom: 0.5rem;
            margin-left: 0.5rem;
        }
        .ri-title-style2 {
            margin-left: 0.5rem;
            display: inline-block;
            margin-top: 5px;
            font-size: 0.8rem;
            margin-bottom: 0.5rem;
        }
    }

    @keyframes rotateArround {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }

    @-webkit-keyframes rotateArround {
        from {
            -webkit-transform: rotate(0deg);
        }
        to {
            -webkit-transform: rotate(360deg);
        }
    }

    @-moz-keyframes rotateArround {
        from {
            -moz-transform: rotate(0deg);
        }
        to {
            -moz-transform: rotate(360deg);
        }
    }

    @-ms-keyframes rotateArround {
        from {
            -ms-transform: rotate(0deg);
        }
        to {
            -ms-transform: rotate(360deg);
        }
    }

    @-o-keyframes rotateArround {
        from {
            -o-transform: rotate(0deg);
        }
        to {
            -o-transform: rotate(360deg);
        }
    }

    /*  */
    @keyframes rotateAr {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }

    @-webkit-keyframes rotateAr {
        from {
            -webkit-transform: rotate(0deg);
        }
        to {
            -webkit-transform: rotate(360deg);
        }
    }

    @-moz-keyframes rotateAr {
        from {
            -moz-transform: rotate(0deg);
        }
        to {
            -moz-transform: rotate(360deg);
        }
    }

    @-ms-keyframes rotateAr {
        from {
            -ms-transform: rotate(0deg);
        }
        to {
            -ms-transform: rotate(360deg);
        }
    }

    @-o-keyframes rotateAr {
        from {
            -o-transform: rotate(0deg);
        }
        to {
            -o-transform: rotate(360deg);
        }
    }
    .activeClass {
        background-color: #e6a23c !important;
        border-color: #e6a23c !important;
    }
}
</style>
